import {
  useReadCalendar,
  useUpdateCalendar,
} from "@clockwise/web-commons/src/util/CalendarContext";
import { useRouter } from "found";
import { useEffect } from "react";
import { useEffectOnce } from "usehooks-ts";
import { hashHistory } from "../../../../util/history.util";
import { CALENDAR_HASH } from "../../constants";
import { getCalendarDatesFromDefault } from "../util/getCalendarDatesFromDefault";
import { getCalendarDatesFromRoute } from "../util/getCalendarDatesFromRoute";
import { getCalendarDatesFromState } from "../util/getCalendarDatesFromState";
import { getCalendarDatesFromStorage } from "../util/getCalendarDatesFromStorage";
import { getCalendarHashFromState } from "../util/getCalendarHashFromState";

export const usePersistCalendarHash = () => {
  const { match } = useRouter();
  const calendarState = useReadCalendar();
  const calendarDispatch = useUpdateCalendar();

  // Set initial calendar dates and mode
  useEffectOnce(() => {
    const [mode, focusDate] =
      getCalendarDatesFromRoute(match) ||
      getCalendarDatesFromStorage(sessionStorage) ||
      getCalendarDatesFromState(calendarState) ||
      getCalendarDatesFromDefault();

    calendarDispatch({
      type: mode === "day" ? "jumpTo-date" : "jumpTo-weekOf",
      payload: focusDate,
    });
  });

  // On Calendar Change: Update Route Hash
  useEffect(() => {
    const calendarHash = getCalendarHashFromState(calendarState);
    hashHistory.replace(calendarHash);
  }, [calendarState]);

  // On Calendar Change: Update Storage
  useEffect(() => {
    const calendarHash = getCalendarHashFromState(calendarState);
    sessionStorage.setItem(CALENDAR_HASH, calendarHash);
  }, [calendarState]);
};
